// Data Science Course Data
import Python from '../assets/data-science/Python.png';
import Numpy from '../assets/data-science/Numpy.png';
import Docker from '../assets/data-science/Docker.png';
import Flask from '../assets/data-science/Flask.png';
import MatPlotLib from '../assets/data-science/MatPlotLib.png';
import Pandas from '../assets/data-science/Pandas.png';
import PyTorch from '../assets/data-science/PyTorch.png';
import Scikit from '../assets/data-science/Scikit.png';
import seaborn from '../assets/data-science/seaborn.png';
import streamLit from '../assets/data-science/streamLit.png';
import TensorFlow from '../assets/data-science/TensorFlow.png';
import { FaLaptopCode } from "react-icons/fa";
import { BsFillPersonCheckFill } from "react-icons/bs";
import { LuSparkles } from "react-icons/lu";
import { FaAward } from "react-icons/fa6";
import { FaPersonChalkboard } from "react-icons/fa6";
import { FaGraduationCap } from "react-icons/fa6";
import { FaUserTie } from "react-icons/fa6";
import { FaExchangeAlt } from "react-icons/fa";

const dataScienceCourse = {
  id: 'data-science',
  title: 'Data Science Training & Internship Program',
  shortTitle: 'Data Science',
  hero: {
    headline: 'Data Science Training and Internship - Certificate Program',
    subheadline: 'UK Industry-Microsoft Partnered Certified Program | Project Portfolio | Live Interactive Mentorship',
    description: 'Join Int-Elligence Tech Solutions Plc, a leading UK-based IT solutions provider, and gain the industry-ready skills needed to secure top data science roles!',
    statistics: [
      { value: '82%', label: 'of UK businesses say data science is critical to growth', ref: 'Tech Nation 2024' },
      { value: '£45K-£80K', label: 'starting salaries for qualified candidates', ref: 'Economic Research Institute' },
      { value: '+231%', label: 'Growth in demand for specialist data skills over five years — compared to +36% across all jobs.', ref: 'Royal Society' },
      { value: '3.5×', label: 'More job postings for data specialists than qualified applicants.', ref: 'Royal Society' }
    ]
  },
  importantNotice: {
    title: 'IMPORTANT NOTICE',      
    requirements: [
      'Treat this as a career accelerator, not just a certificate.',
      'Are prepared for real-world projects with deadlines.',
      'Proactively seek 1:1 mentorship (not passive learning).'
    ],
    reason: 'Our mentors invest 30+ hours per student - we prioritize those serious about landing UK data science roles.'
  },
  programHighlights: {
    duration: '3 Months',
    features: [
      {
        icon: <FaLaptopCode />,
        title: '1. Hands-On Learning',
        description: 'Work on numerous real-world projects and build a strong portfolio'
      },
      {
        icon: <BsFillPersonCheckFill/>,
        title: '2. Weekly 1:1 Mentorship - Learn, Refine, and Progress',
        description: 'At Int-Elligence Tech Solutions, mentorship is at the heart of our program. Your UK-based mentor will meet with you weekly to review projects, discuss challenges, and provide career guidance — ensuring you always have an expert by your side as you grow.'
      },
      {
        icon: <LuSparkles/>,
        title: '3. Guided by the Minds Shaping the Future of Data Science',
        description: 'Our mentors are seasoned data professionals from across UK academia, finance, healthcare, and consulting. They combine deep theoretical knowledge with applied experience, ensuring you gain industry-ready skills from real-world practitioners.'
      },
      {
        icon: <FaPersonChalkboard/>,
        title: '4. Career-Focused Training',
        description: 'Designed to make you job-ready in the growing data science industry'
      },
      {
        icon: <FaAward/>,
        title: '5. Microsoft-Partnered Certification',
        description: 'Enhance your CV and boost employability in the UK and beyond'
      },      
    ]
  },
  toolsCovered: [
    { name: 'Python', description: 'Essential for data analysis & automation', image: Python },
    { name: 'NumPy', description: 'Powerful library for numerical and matrix computations', image: Numpy },
    { name: 'Scikit-learn', description: 'Machine learning library for classification, regression & clustering', image: Scikit },
    { name: 'Matplotlib', description: 'Data visualization techniques and chart creation', image: MatPlotLib },
    { name: 'Pandas', description: 'Data manipulation and analysis with DataFrames', image: Pandas },
    { name: 'TensorFlow', description: 'Deep learning and AI applications', image: TensorFlow },
    { name: 'PyTorch', description: 'Flexible deep learning framework for research and production', image: PyTorch },
    { name: 'Streamlit', description: 'Framework for creating interactive data apps easily', image: streamLit },
    { name: 'Seaborn', description: 'Statistical data visualization built on top of Matplotlib', image: seaborn },
    { name: 'Flask', description: 'Lightweight web framework for building Python-based APIs', image: Flask },
    { name: 'Docker', description: 'Containerization platform for deploying and scaling applications efficiently', image: Docker }
  ],
  whyThisProgram: [
    {
      title: 'UK Registered Company',
      description: 'We are a UK-registered company under the name Int-Elligence Tech Solutions Plc, registered with Companies House bearing registration number - 15667387.'
    },
    {
      title: 'UK Skills Shortage',
      description: '63% of UK data roles go unfilled due to lack of qualified applicants (STEM Learning).'
    },
    {
      title: 'Industry-Aligned Training',
      description: 'Learn the tools and techniques used by top UK-based companies.'
    },
    {
      title: 'Taught by Senior UK Industry Experts',
      description: 'Ex-Big Tech, FTSE 500, AI start-up and UK universities experts.'
    },    
    {
      title: 'Employer-Aligned Projects',
      description: 'Solve real problems in finance, healthcare, hospitality, banking and e-commerce, etc.'
    },
    {
      title: 'UK-Based Credibility',
      description: 'Training with a UK-based firm ensures your skills are aligned with local industry standards.'
    }
  ],
  programDetails: {
    overview: {
      title: 'Program Overview and Duration',
      description: 'Our Data Science Training and Internship - Certificate Program is designed to provide a comprehensive learning and hands-on experience. You\'ll gain access to our in-house online learning platform, which serves as the foundation of your journey. The program spans 3 months:',
      phases: [
        {
          title: 'First 2 months',
          description: 'This phase combines self-paced learning with practical tasks, assignments, and mini-projects, where you\'ll collaborate with experienced professionals to apply your skills in a guided environment.'
        },
        {
          title: 'Final month',
          description: 'Work on real-world projects across industries such as forex, healthcare, retail, and banking - ideal for building a robust, job-ready portfolio.'
        }
      ]
    },
    modeOfDelivery: {
      title: 'Mode of Delivery',
      description: 'The program is fully remote and designed with flexibility in mind. You\'ll engage in self-paced learning, mini-projects, and weekly mentor check-ins to ensure steady progress. This is a learning, and real-world projects focused unpaid program.'
    },
    commitment: {
      title: 'Commitment and Flexibility',
      description: 'We understand our participants come from various academic and professional backgrounds. Our structure is self-directed (we expect participants to take out at least 8 hours per week) with defined milestones offering you the freedom to learn on your schedule while meeting weekly deliverables.'
    },
    curriculum: {
      title: 'Curriculum and Hands-On Experience',
      description: 'The curriculum is structured to cover both foundational knowledge and practical application. You will:',
      points: [
        'Learn key concepts and industry best practices through engaging online content.',
        'Work on numerous tasks, assignments, and mini-projects under the supervision of seasoned professionals.',
        'Apply your knowledge to real-world projects in the final phase, showcasing your ability to solve real industry problems.'
      ]
    },
    mentorship: {
      title: 'Mentorship',
      description: 'You will be assigned a dedicated UK-based mentor. Weekly live 1:1 sessions (30–45 minutes) are held (typically on Saturdays), where mentors provide tailored feedback on your tasks and guidance on your technical or career-related questions.'
    },
    certification: {
      title: 'Certification and Credentials',
      description: 'We are a proud Microsoft Partner, and our Partner ID is 6843023. Upon successful completion, you receive a Microsoft-Partnered Certificate issued by Int-Elligence Tech Solutions Plc - this certificate strengthens your professional profile in the UK and globally.'
    },
    careerAdvancement: {
      title: 'Career Advancement',
      description: 'Top-performing candidates may have the chance to work with us on our clients projects with contractual basis post completion of the program, following a successful interview.',
      additionalInfo: 'Our Data Science Training and Internship - Certificate Program has a proven track record of transforming talent into skilled professionals. Many of our interns have leveraged this opportunity to achieve remarkable career advancements, both within our company and across the industry.',
      careerPaths: 'Completing the Data Science Training and Internship – Certificate Program at IntElligence Tech Solutions enables participants to transition into or advance within data-driven roles across multiple industries. Graduates develop practical expertise in data analysis, machine learning, and real-world problem solving, opening pathways to roles such as Data Analyst, Data Scientist, Machine Learning Engineer, Business Intelligence Analyst, and Data Engineer. The program is designed to bridge the gap between theory and industry application, empowering learners to upskill, reskill, or pivot careers with confidence through hands-on projects, mentorship, and exposure to real business use cases.'
    }
  },
  whoShouldApply: [
    {
      icon: <FaGraduationCap/>,
      title: 'Graduates',
      description: 'Build a portfolio that stands out in applications.'
    },
    {
      icon: <FaUserTie/>,
      title: 'Professionals',
      description: 'Upskill for promotions or sector switches.'
    },
    {
      icon: <FaExchangeAlt/>,
      title: 'Career Switchers',
      description: 'Break into tech with mentor-led projects.'
    }
  ],
  aluminiVideos: [
    {
      id: 1,
      name: "Yemisi Ohiorenoya",
      videoUrl: "https://pub-1a559929ef4149c4abff31d55531033a.r2.dev/yemisi%20(2).mp4",
    },
    {
      id: 2,
      name: "Afifa Anis",
      videoUrl: "https://pub-1a559929ef4149c4abff31d55531033a.r2.dev/afifa.mp4",
    },
    {
      id: 3,
      name: "Obanla Oluwaseun",
      videoUrl: "https://pub-1a559929ef4149c4abff31d55531033a.r2.dev/obanla.mp4",
    },
  ],
  whyAlumniGetHired: [
    {
      icon: '✅',
      title: 'UK-Tuned Training',
      description: 'Curriculum co-designed with London AI start-ups & FTSE 350 firms'
    },
    {
      icon: '✅',
      title: 'Portfolio Builder',
      description: '5x real-world projects (e.g., fraud detection, sales forecasting etc)'
    },
    {
      icon: '✅',
      title: 'Career support',
      description: 'CV reviews, interview prep, and LinkedIn optimization.'
    },      
  ],
  testimonialLink: 'https://share.google/wv45vd8NA35pedVmw',
  contactEmail: 'hr@int-elligence.co.uk',
  footerNote: 'The UK needs 250,000+ data professionals by 2026 – be one of them!" – TechUK'
};

export default dataScienceCourse;